import { CombinedFlowAdapter, AliasedExpression, KeywordProperties } from "./combined.flow.adapter";
import { ChipExpression } from "@nrwl/query-emitter";
import { join } from 'lodash';

export class GroupbyFlowSecAdapter extends CombinedFlowAdapter {
  constructor(config) {
    super(config);
  }

  private chooseNamesAndAliases(expression, mappingTable, aliases, fieldList) {
    const mappedName = mappingTable.get(expression.keyword);
    if (!mappedName) {
      // no mapping found. send raw field name
      fieldList.push(expression.keyword);
      return;
    }
    if (!this.useAliases()) {
      // right now we still use some KPIs that are not based on directional logic
      // (even if it looks like this is wrong, and they will have to be made directional)
      // hence we want to use 'raw' field names, such as site2, user1, etc.
      fieldList.push(mappedName.fieldName);
      return;
    }

    switch (mappedName.placement) {
      case 'no-alias':
        fieldList.push(mappedName.fieldName);
        break;
      case 'src': {
        fieldList.push(mappedName.alias);
        aliases.source[mappedName.alias] = mappedName.fieldPrefix;
      }
        break;
      case 'dst': {
        fieldList.push(mappedName.alias);
        aliases.source[mappedName.alias] = mappedName.fieldPrefix;
      }
        break;
    }
  }

  // we want avoid outputing src/dest keys, if there are no aliases on that key
  outputAliases(aliases) {
    const result:any = {};
    if (aliases.source && Object.keys(aliases.source).length > 0) {
      result.source = aliases.source;
    }
    if (aliases.destination && Object.keys(aliases.destination).length > 0) {
      result.destination = aliases.destination;
    }
    return result;
  }

  build(value: ChipExpression[], mappingTable: Map<string, KeywordProperties>): AliasedExpression {
    if (!value) {
      return { expression: '',
aliases: undefined };
    }
    const aliases = {
      source: {},
      destination: {}
    }
    const fieldList: string[] = [];
    value.forEach(expression => {
      this.chooseNamesAndAliases(expression, mappingTable, aliases, fieldList);
    });

    return {
      expression: join(fieldList, ','),
      aliases: this.outputAliases(aliases)
    }
  }

}
